// Helper
import { datetime } from 'helpers/format'

// Model
import Model from 'models/Model'

export default class TicketComment extends Model {
  get id() {
    return this.model.id
  }

  get userName() {
    return this.model.user
  }

  get createdAt() {
    return datetime(this.model.date, null, 'MMM dd, yyyy | hh:mma')
  }

  get content() {
    return this.model.content
  }

  get isAdmin() {
    return this.model.userType === 1
  }

  get files() {
    if (Array.isArray(this.model.attachmentFileNames)) {
      return this.model.attachmentFileNames.map((name) => ({
        name,
        status: 'done',
      }))
    }

    return []
  }
}
